(function () {
	'use strict';
	angular.module('jcsfApp').controller('projectController', projectController);

	projectController.$inject = [
		'$controller',
		'$rootScope',
		'$scope',
		'$filter',
		'events',
		'authService',
		'dataService',
	];
	function projectController(
		$controller,
		$rootScope,
		$scope,
		$filter,
		events,
		authService,
		dataService
	) {
		$controller('baseController', { $scope: $scope });
		var vm = this;

		authService.fillAuthData();

		vm.userJCCCC = authService.authentication.userInfo.JCCCC;
		vm.baseUrl = '/api/project/';
		vm.projectDocuments = [];
		vm.orderBy =
			sessionStorage.getItem('fireHourProjectsOrderBy') || 'LastName';
		vm.orderByReverse = false;
		vm.setOrderBy = setOrderBy;
		var authentication = authService.authentication;
		vm.boolToStr = function (arg) {
			return arg ? 'Yes' : 'No';
		};
		vm.boolToStr2 = function (arg) {
			return arg === true ? 'Yes' : 'No';
		};
		vm.project = {
			ProjectId: -1,
			Active: 1,
			Deleted: 0,
			ProjectTitle: '',
			ProjectSubTitle: '',
			Agency: '',
			ProjectDescription: '',
			PartnerOrganization: '',
			ProjectResourceOrderNo: '',
			HazardType: '',
			ProgramPartner: '',
			PartnerOrganizationId: 0,
			ProgramPartnerId: vm.userJCCCC || 0,
			ProjectSiteLocation: '',
			Acres: 0,
			Region: '',
			ProjectState: '',
			ProjectStateName: '',
			ForestDistrict: '',
			Justice40: '',
			State: '',
			SpiWCS: '',
			SpiPFS: '',
			SpiCWPP: '',
			SpiGAOA: '',
			SpiJCP: '',
			SpiCFLRP: '',
			SpiNA: '',
			WUI: 0,
		};
		vm.studentResources = {};
		vm.resources = [];
		vm.forests = [];
		vm.rsas = [];
		vm.centers = [];
		vm.students = [];
		vm.selectedStudents = [];
		vm.centerStudents = [];
		vm.changeCenter = centerChanged;
		vm.CalcFiscalYear = function () {
			var dToday = new Date();
			return dToday.getFullYear();
		};
		vm.cancel = function () {
			$scope.publish(events.message._GET_PROJECT_, [vm.project.ProjectId]);
		};

		vm.canSaveProject = function (proj) {
			if (
				proj.PartnerOrganizationId === 327 &&
				!proj.PartnerOrganizationIdOther
			) {
				return false;
			}
			if (
				(proj.ProjectResource === 'Haz. Fuels' ||
					proj.ProjectResource === 'Wildfire') &&
				(Number(proj.Acres) < 0 || !proj.Acres)
			) {
				return false;
			}
			if (proj.ProjectResource === 'All Hazards' && !proj.HazardType) {
				return false;
			}
			if (proj.ProjectResource === 'Other' && !proj.ProjectTypeOther) {
				return false;
			}
			return true;
			// (
			// 	proj.ProjectTitle.length &&
			// 	proj.PartnerOrganizationId &&
			// 	proj.Agency.length &&
			// 	proj.ProjectResource.length &&
			// 	proj.ProjectTitle.length &&
			// 	proj.ProjectResourceOrderNo.length === 13
			// );
		};
		vm.save = function () {
			vm.project.Active = 1;
			if (vm.project.ProjectId > 0) {
				vm.project.LastModifiedBy = authentication.userName;
			} else {
				vm.project.CalendarYear = vm.CalcFiscalYear();
				vm.project.Creator = authentication.userName;
			}
			$scope.publish(events.message._SAVE_PROJECT_, [vm.project]);
		};
		vm.cancelStudentHour = function () {
			vm.selectedStudentHour = {
				IsPLC: true,
				CalendarYear: vm.CalcFiscalYear(),
			};

			$scope.publish(events.message._GET_PROJECT_, [vm.project.ProjectId]);
		};
		vm.hazards = ['Floods', 'Hurricanes', 'Tornados'];
		vm.showAcres = function (resource) {
			return (
				resource !== undefined &&
				(resource === 'Haz. Fuels' || resource === 'Wildfire')
			);
		};
		vm.showHazards = function (resource) {
			return resource !== undefined && resource === 'All Hazards';
		};
		vm.showPartnerOrgOther = function (resource) {
			return resource !== undefined && resource === 327;
		};
		vm.showProjTypeOther = function (resource) {
			return resource !== undefined && resource === 'Other';
		};

		vm.selectedStudentHour = { IsPLC: true, CalendarYear: vm.CalcFiscalYear() };
		vm.saveStudentHours = function (fh) {
			if (fh.FireHourId > 0) {
				fh.LastModifiedBy = authentication.userName;
			} else {
				fh.Creator = authentication.userName;
				fh.CalendarYear = vm.CalcFiscalYear();
			}
			fh.ProjectId = vm.project.ProjectId;

			vm.save();

			for (const student of vm.selectedStudents) {
				const sr = structuredClone(fh);
				sr.StudentId = student.StudentId;
				$scope.publish(events.message._SAVE_FIRE_HOUR_, [sr]);
			}

			vm.selectedStudentHour = createFireHour();
			vm.selectedStudents = [];
		};

		vm.deleteFireHour = function (fh) {
			const confirmed = window.confirm(
				'Are you sure you want to delete ' +
					fh.FirstName +
					' ' +
					fh.LastName +
					' Hours (' +
					fh.Hours +
					') ?'
			);
			if (confirmed) {
				$scope.publish(events.message._DELETE_FIRE_HOUR_, [fh.FireHourId]);
			}
		};

		vm.isStudentActive = function isStudentActive(fh) {
			return vm.students.some(function (st) {
				return st.StudentId === fh.StudentId;
			});
		};

		vm.editFireHour = function (fh) {
			const student = vm.students.find(function (st) {
				return st.StudentId === fh.StudentId;
			});

			if (student) {
				vm.selectedStudents = [student];
			} else {
				alert('Student not found in active records. Aborting edit attempt.');
				return;
			}

			vm.selectedStudentHour = createFireHour(fh);
			vm.selectedStudentHour.Hours = parseFloat(
				Math.round(vm.selectedStudentHour.Hours * 100) / 100
			);
		};

		vm.totalHours = function () {
			if (vm.project == null || vm.project.Students == null) return;
			return vm.project.Students.reduce(function (acc, item) {
				return acc + item.Hours;
			}, 0);
		};

		activate();

		//uncheck Project verified checkbox based on update
		$scope.$watch(
			'vm.selectedStudentHour.DispatchDate',
			function (newValue, oldValue) {
				if (newValue !== oldValue && newValue && oldValue) {
					vm.project.ProjectVerified = false;
				}
			}
		);
		$scope.$watch(
			'vm.selectedStudentHour.DateReturned',
			function (newValue, oldValue) {
				if (newValue !== oldValue && newValue && oldValue) {
					vm.project.ProjectVerified = false;
				}
			}
		);
		vm.handlefirePVChange = function (e) {
			vm.project.ProjectVerified = false;
		};

		$scope.subscribe(
			events.message._GET_PROJECT_COMPLETE_,
			onGetProjectComplete
		);
		$scope.subscribe(
			events.message._GET_PROJECT_RESOURCES_LIST_COMPLETE_,
			onGetProjectResourcesComplete
		);
		$scope.subscribe(
			events.message._GET_JCCENTER_LIST_COMPLETE_,
			onGetJcCentersComplete
		);
		$scope.subscribe(events.message._GET_RSA_LIST_COMPLETE_, onGetRSAsComplete);
		$scope.subscribe(
			events.message._SAVE_PROJECT_COMPLETE_,
			onSaveProjectComplete
		);
		$scope.subscribe(
			events.message._SAVE_FIRE_HOUR_COMPLETE_,
			onSaveFireHourComplete
		);
		$scope.subscribe(
			events.message._DELETE_FIRE_HOUR_COMPLETE_,
			onDeleteFireHourComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_LIST_COMPLETE_,
			onGetStudentsComplete
		);
		$scope.subscribe(
			events.message._GET_FOREST_LIST_COMPLETE_,
			onGetForestsComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_RESOURCES_LIST_COMPLETE_,
			onGetStudentResourcesComplete
		);
		function activate() {
			if (
				authentication.userName == null ||
				!authentication.isAuth ||
				$rootScope.$stateParams.id == null
			) {
				$scope.$state.go('home');
			}

			$scope.publish(events.message._GET_PROJECT_, [
				$rootScope.$stateParams.id,
			]);
			$scope.publish(events.message._GET_JCCENTER_LIST_, []);
			$scope.publish(events.message._GET_RSA_LIST_, []);
			$scope.publish(events.message._GET_PROJECT_RESOURCES_LIST_, []);
			$scope.publish(events.message._GET_STUDENT_RESOURCES_LIST_, []);
			$scope.publish(events.message._GET_FOREST_LIST_, []);
		}
		function centerChanged(id) {
			vm.centerStudents = [];
			vm.handlefirePVChange();
			$scope.publish(events.message._GET_STUDENT_LIST_, [true, id]);
		}
		function onGetStudentsComplete(results) {
			vm.students = results;
			vm.centerStudents = results;
			// if(vm.project){ centerChanged(vm.project.ProgramPartnerId);}
		}
		function onGetProjectComplete(results) {
			vm.project = results;
			if (vm.userJCCCC !== 29) {
				vm.project.ProgramPartnerId = vm.userJCCCC;
			}
			getProjectDocuments(vm.project.ProjectId);
			$scope.publish(events.message._GET_STUDENT_LIST_, [
				true,
				vm.project.ProgramPartnerId,
			]);
		}
		function onGetStudentResourcesComplete(results) {
			vm.studentResources = results;
		}
		function onGetForestsComplete(results) {
			vm.forests = results;
		}
		function onGetProjectResourcesComplete(results) {
			vm.resources = results;
		}
		function onSaveProjectComplete(results) {
			onGetProjectComplete(results);
		}
		function onGetJcCentersComplete(results) {
			vm.centers = results;

			if (vm.project.ProjectId < 1) {
				vm.project.ProgramPartner = $filter('filter')(vm.centers, {
					CenterId: vm.project.ProgramPartnerId,
				})[0].JCCCC;
			}
		}
		function onGetRSAsComplete(results) {
			vm.rsas = results;
		}
		function onSaveFireHourComplete(results) {
			if (results && results.FireHourId > 0) {
				var match;
				if (vm.project.Students) {
					match = vm.project.Students.filter(function (item) {
						return Number(item.FireHourId) === Number(results.FireHourId);
					})[0];
				}
				if (match) {
					var inx = vm.project.Students.indexOf(match);
					vm.project.Students[inx] = results;
				} else {
					vm.project.Students.push(results);
				}
			}
		}
		function onDeleteFireHourComplete() {
			$scope.publish(events.message._GET_PROJECT_, [vm.project.ProjectId]);
		}
		function createFireHour(src) {
			var self = {};
			src = src || {};
			self.FireHourId = src.FireHourId || 0;
			self.StudentId = src.StudentId || 0;
			self.CalendarYear = src.CalendarYear || vm.CalcFiscalYear();
			self.FirstName = src.FirstName || '';
			self.MiddleInitial = src.MiddleInitial || '';
			self.LastName = src.LastName || '';
			self.ProjectId = vm.project.ProjectId || 0;
			self.ResourceId = src.ResourceId || 0;
			src.ProjectTitle = vm.project.ProjectTitle;
			src.ProjectSubTitle = vm.project.ProjectSubTitle;
			self.DispatchDate = new Date(src.DispatchDate);
			self.DateReturned = new Date(src.DateReturned);
			self.IsPLC = src.IsPLC || true;
			self.Hours = src.Hours || 0;
			self.Active = src.Active || 1;
			self.Deleted = src.Deleted || 0;
			self.Creator = src.Creator || '';
			self.LastModifiedBy = src.LastModifiedBy || '';
			self.CreatedDate = new Date(src.CreatedDate);
			self.CreatedDateString = src.CreatedDateString || '';
			self.CreatedBy = src.CreatedBy || '';
			self.LastUpdated = new Date(src.LastUpdated);
			self.LastUpdatedString = src.LastUpdatedString || '';
			self.LastUpdatedBy = src.LastUpdatedBy || '';
			self.UpdatingApp = src.UpdatingApp || '';
			return self;
		}

		//--------------------------------------------------------------
		function getProjectDocuments(projectId) {
			dataService
				.get(vm.baseUrl + 'getProjectFiles/' + projectId)
				.then(function (result) {
					vm.projectDocuments = result;
				});
		}

		function deleteDocumentFromServer(fileID, fileName) {
			//let base64Name = btoa(fileName);
			//dataService.get(vm.baseUrl + "DeleteProjectFile/" + fileID + "/" + base64Name).then(function (result) {
			dataService
				.get(vm.baseUrl + 'DeleteProjectFile/' + fileID)
				.then(function (result) {
					getProjectDocuments(vm.project.ProjectId);
					//vm.projectDocuments = result;
				});
		}

		/**
		 *
		 * @param {string} column
		 */
		function setOrderBy(column) {
			vm.orderByReverse = vm.orderBy === column ? !vm.orderByReverse : false;
			vm.orderBy = column;
			sessionStorage.setItem('fireHourProjectsOrderBy', column);
		}

		vm.viewFile = function (fileName) {
			window.open('Uploads/' + fileName);
		};

		vm.deleteFile = function (fileID, fileName) {
			if (confirm('Are you sure you want to delete this document?')) {
				deleteDocumentFromServer(fileID, fileName);
			}
		};

		vm.doSaveFile = function () {
			let abc = vm.project.ProjectId;
			doFileUploads(vm);
		};

		function doFileUploads(objProject) {
			let ProjectId = objProject.project.ProjectId;
			let LastUpdatedBy = objProject.project.LastUpdatedBy;

			if (document.getElementById('fileUploadDocs').value != '') {
				var file = document.getElementById('fileUploadDocs').files[0];
				var fileName = document.getElementById('fileUploadDocs').files[0].name;
				if (window.FormData !== undefined) {
					var data = new FormData();
					data.append('file', file);
					//fileName = btoa(fileName);

					$.ajax({
						type: 'POST',
						url:
							objProject.baseUrl +
							'UploadFile/' +
							ProjectId +
							'/' +
							LastUpdatedBy +
							'/' +
							'abc',
						contentType: false,
						processData: false,
						data: data,
						success: function (result) {
							console.info(result);
							getProjectDocuments(objProject.project.ProjectId);
						},
						error: function (xhr, status, p3, p4) {
							var err = 'Error ' + ' ' + status + ' ' + p3 + ' ' + p4;
							if (xhr.responseText && xhr.responseText[0] == '{')
								err = JSON.parse(xhr.responseText).Message;
							console.error(err);
						},
					});
				}
				document.getElementById('fileUploadDocs').value = '';
				document.getElementById('btnSaveDoc').disabled = true;
			}
		}
	}
})();
